module.exports = __webpack_public_path__ + "img/LOGOSGPF256Prancheta 1.6fa75f0b.png";